var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIcon12(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.724,
    height: 34.869,
    viewBox: "0 0 26.724 34.869",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2402",
    "data-name": "Rectangle 2402",
    width: 26.724,
    height: 34.869,
    fill: "#ffe800"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10465",
    "data-name": "Group 10465",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10465-2",
    "data-name": "Group 10465",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29539",
    "data-name": "Path 29539",
    d: "M1.244,23.952,0,34.056a.735.735,0,0,0,.726.813H25.993a.735.735,0,0,0,.726-.813l-1.241-10.1A.736.736,0,0,0,25.1,23.4l-6.791-3.632-1.259-1.6v-1.7a8,8,0,0,0,3.257-6.235,4.2,4.2,0,0,0,.885-4.108A9.019,9.019,0,0,0,15.707.244a3.729,3.729,0,0,0-3.348.307A2.476,2.476,0,0,0,12.053.29a2.192,2.192,0,0,0-2.221,0A8.142,8.142,0,0,0,5.474,6.354a3.766,3.766,0,0,0,.942,2.905V9.55a8.425,8.425,0,0,0,3.277,6.828v1.74L8.618,19.5H8.561L1.639,23.373a.734.734,0,0,0-.394.579m12.167,9.442h-1.2L13,26.366a.787.787,0,0,0,0-.355l-.923-2.255,1.316-1.006,1.359,1.045-.923,2.179a.707.707,0,0,0-.046.355l.807,7.051ZM10.419,19.537l1.891,2.179-1.774,1.365L9.7,20.452Zm5.886,0,.726.923L16.2,23.089l-1.744-1.365Zm.949,4.975,1-3.144L24.067,24.5l1.089,8.912H16.021l-.8-7.033.726-1.675.208.159a.727.727,0,0,0,.442.151.7.7,0,0,0,.221,0,.715.715,0,0,0,.442-.506M6.912,6.543a6.686,6.686,0,0,1,3.42-4.858c.561-.276.844-.234.881-.211a1.447,1.447,0,0,1,.406.53.725.725,0,0,0,1.243.079c.443-.64,1.265-.791,2.441-.444A7.7,7.7,0,0,1,19.789,6.5a2.9,2.9,0,0,1-.261,2.4l-.378-.144C16.514,7.712,14.017,6.739,13.1,4.08a.729.729,0,0,0-.678-.465h-.151a.725.725,0,0,0-.594.726A4.8,4.8,0,0,1,7.434,8.234a2.288,2.288,0,0,1-.522-1.691m.945,3.125a6.42,6.42,0,0,0,3.972-2.232,6.248,6.248,0,0,0,.76-1.177c1.419,2.036,3.757,2.951,6.03,3.844l.234.094c-.182,3.39-2.531,5.993-5.493,5.993s-5.447-2.921-5.5-6.521m5.5,7.99a6.362,6.362,0,0,0,2.236-.409v.893l-2.236,2.564-2.236-2.592v-.907a6.121,6.121,0,0,0,2.236.435ZM2.641,24.5l5.811-3.231,1.032,3.246a.729.729,0,0,0,.473.473.673.673,0,0,0,.216,0,.72.72,0,0,0,.444-.151l.249-.19.726,1.706-.843,7.067h-9.2Z",
    transform: "translate(0 0)",
    fill: "#ffe800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon12);
export default __webpack_public_path__ + "static/media/social_icon12.91f53906eec6ccb472abd3a307133673.svg";
export { ForwardRef as ReactComponent };